// removed by extract-text-webpack-plugin
module.exports = {"summary":"_25CFJ","count":"_2KoeF","name":"_1vOU4","fy":"_6ccKs","status":"_2iXwy","lastUpdated":"_2-8Eb","view":"_31mOK","header":"_2zXPa","description":"uwSs8","docIcon":"_1z-oj","docLink":"_3JKuw","docDate":"_3Lt9q","plandocuments":"vavSl"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerReports/PartnerPlan/columns.scss
// module id = 259
// module chunks = 0